import {
  TreeItem as MuiTreeItem,
  TreeItemProps as MuiTreeItemProps,
} from '@mui/x-tree-view';
import { TreeItemSx } from './TreeItemProps';

function TreeItem(props: MuiTreeItemProps) {
  return <MuiTreeItem {...props} sx={{ ...TreeItemSx, ...props.sx }} />;
}

export default TreeItem;
